module.exports = "<div class=\"avatar\" [ngClass]=\"className\"><span>{{displayValue}}</span></div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/avatar/avatar.component.html
// module id = ../../../../../src/app/shared/components/avatar/avatar.component.html
// module chunks = main